// extracted by mini-css-extract-plugin
export default {"root":"auth__root__GeILz","container":"auth__container__RV38H","wrapper":"auth__wrapper__iINWb"};